import store from "../../store/index.js";


export function updateDocumentTitle(title) {
    store.dispatch("platform/updateSectionTitle", title);
}